import React from 'react'

const Term = () => {
  return (
    <div style={{width:"60%",margin:"auto",marginTop:"50px"}}>
      <h1>Terms of Service</h1>
      <br/>
      <p>Below you will find Indeed’s terms and conditions and information about our cookie and privacy policies. We know we are giving a great deal of information. Indeed does this for a reason: we want you to have as much knowledge about what we do for you at Indeed as is possible. We do not want you to wonder about any of our processes or procedures or guess as to what your interaction with Indeed means. We want you to understand it, which is why we must explain it in detail. We urge you to read these terms or any section of interest to you. You are agreeing to proceed under them.</p>
      <h3>Indeed General Terms of Service</h3>
      <p>Last Updated: August 17, 2022</p>
      <h2>Introduction to Indeed’s Terms of Service</h2>
      <br/>
      <p>Each time you access or use Indeed’s online and/or mobile services and websites, including but not limited to any Indeed mobile application and browser extension or plugin (collectively the “Indeed Apps”), regardless of where it is downloaded from, and any software, service, feature, product, program and element provided by or on behalf of Indeed on or in connection with such services or websites (collectively, the “Site”), including, but not limited to, any products, programs, and services described in these Terms of Service, (a) you represent that you have read and understand the Cookie Policy and Privacy Policy; and (b) you are agreeing to the terms and conditions of these Terms of Service (the “Agreement”) then in effect with the following entity or entities:</p>
      <br/>
      <h6>For Job Seekers:</h6>
      <br/>
      <li>
      If you are located within the United States, the Site is provided by Indeed Inc., 6433 Champion Grandview Way, Building 1, Austin, TX, 78750
      </li>
      <li> If you are located in Japan, the Site is provided by Indeed Japan K.K.</li>

      <li>     If you are located outside of the United States or Japan, the Site is provided by Indeed Ireland Operations Limited.
      </li>
      <br />
      <h5>For Employers :</h5>
      <br/>
      <ul>
        <li>
        If you are located in Brazil, Employer services are provided by Indeed Brasil Pesquisa de Empregos Ltda., Rua Fidêncio Ramos, 302, Torre B, 12º andar, São Paulo, SP, 04551-010, Brasil.
        </li>
        <li>
        If you are located in the United States, Employer services are provided by Indeed, Inc., 6433 Champion Grandview Way, Building 1, Austin, TX, 78750, USA.
        </li>
        <li>
        If you are located in India, Employer services are provided by Indeed India Operations (Pte.) Ltd., Ground Floor, Block C, Divyasree Omega Hitech City Road, Kondapur, Hyderabad TG 500084 India, solely with
        </li>
        <li>
        If you are located in the Asia-Pacific Region*, Employer services are provided by Indeed Singapore Operations (Pte.) Ltd., 10 Collyer Quay #24-01, Ocean Financial Centre, Singapore 049315.
        </li>
        <li>
        If you are located in Japan, services other than employment placement services are provided by Indeed Japan K.K., 6th Floor, Sumitomo Fudosan Azabu-juban Bldg. 1-4-1, Mita, Minato-ku, Tokyo 108-0073, Japan.
        </li>
        <li>
        If you are located in Japan and established an account with Indeed Singapore prior to October 1, 2021, services other than employment placement services are provided by Indeed Singapore Operations (Pte.) Ltd., 10 Collyer Quay #24-01, Ocean Financial Centre, Singapore 049315.
        </li>
      </ul>

    </div>
  )
}

export default Term
